import React, { useState, useEffect } from 'react';
import { ArrowUp, MessageCircle, Phone, X } from 'lucide-react';

export default function ActionButtons() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);

  // Lắng nghe sự kiện scroll để hiển thị nút Scroll To Top
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className="fixed bottom-6 left-6 z-50 flex space-y-3">
      {/* Nút Gọi Điện Nhanh */}
      <a
        href="tel:0901234567"
        className="p-3.5 bg-emerald-600 text-white rounded-full shadow-lg hover:bg-emerald-700 transition-all transform hover:scale-110 flex items-center justify-center group relative"
        title="Gọi hotline"
      >
        <Phone className="w-5 h-5 animate-bounce" />
        <span className="absolute left-14 bg-slate-900 text-white text-[11px] font-bold px-3 py-1.5 rounded-xl whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none shadow-xl">
          Hotline: 090.123.4567
        </span>
      </a>

      {/* Nút Hỗ Trợ Chat / Zalo */}
      <div className="relative">
        <button
          onClick={() => setIsChatOpen(!isChatOpen)}
          className="p-3.5 bg-indigo-600 text-white rounded-full shadow-lg hover:bg-indigo-700 transition-all transform hover:scale-110 flex items-center justify-center group"
          title="Tư vấn trực tuyến"
        >
          {isChatOpen ? <X className="w-5 h-5" /> : <MessageCircle className="w-5 h-5" />}
          <span className="absolute left-14 bg-slate-900 text-white text-[11px] font-bold px-3 py-1.5 rounded-xl whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none shadow-xl">
            Tư vấn trực tuyến
          </span>
        </button>

        {/* Hộp Thoại Chat Nhanh */}
        {isChatOpen && (
          <div className="absolute left-0 bottom-16 w-72 bg-white rounded-3xl shadow-2xl border border-slate-100 p-4 space-y-3 animate-slide-up text-slate-900">
            <div className="flex items-center space-x-3 pb-3 border-b border-slate-100">
              <div className="w-9 h-9 bg-indigo-100 rounded-full flex items-center justify-center text-indigo-600 font-bold text-xs">
                LX
              </div>
              <div>
                <h4 className="text-xs font-bold">Hỗ Trợ JapanICHIBA</h4>
                <p className="text-[10px] text-emerald-500 font-semibold">● Đang hoạt động</p>
              </div>
            </div>
            <p className="text-xs text-slate-600 leading-relaxed">
              Xin chào! Chúng tôi có thể giúp gì cho bạn hôm nay?
            </p>
            <div className="space-y-2 pt-1">
              <a
                href="https://zalo.me"
                target="_blank"
                rel="noreferrer"
                className="w-full py-2 bg-blue-600 text-white rounded-xl text-xs font-bold flex items-center justify-center space-x-2 hover:bg-blue-700 transition"
              >
                <span>Chat qua Zalo</span>
              </a>
              <a
                href="https://m.me"
                target="_blank"
                rel="noreferrer"
                className="w-full py-2 bg-indigo-50 text-indigo-600 rounded-xl text-xs font-bold flex items-center justify-center space-x-2 hover:bg-indigo-100 transition"
              >
                <span>Facebook Messenger</span>
              </a>
            </div>
          </div>
        )}
      </div>

      {/* Nút Scroll To Top */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="p-3.5 bg-slate-900 text-white rounded-full shadow-lg hover:bg-slate-800 transition-all transform hover:scale-110 flex items-center justify-center border border-slate-800 animate-fade-in"
          title="Lên đầu trang"
        >
          <ArrowUp className="w-5 h-5" />
        </button>
      )}
    </div>
  );
}